import { flagSet } from "@coreui/icons";

const ORDER_STATUS = {
  CREATE: 0,
  PAYMENT_WAIT: 10,
  APPROVAL: 25,
  CANCELED: 50,
  ALERT: 75,
  PRODUCER_IN_CHARGE: 100,
  MARKET_ARRIVED: 200,
  MARKET_STOCK: 201,
  MARKET_IN_CHARGE: 205,
  ISLAND_ARRIVED: 300,
  ISLAND_IN_CHARGE: 305,
  FAMILY_IN_CHARGE: 400,
  DELIVERED: 500,
  PAID: 550,
  ERROR: 60,
};

const ORDER_ACTION = {
  CANCELLATION: "cancellation",
  DONE: "done",
  FILTER: "filter",
  INCIDENT: "incident",
  INCIDENT_EDIT: "incident_edit",
  UNDONE: "undone",
  ADD: "add",
};

const LINES = {
  OTHER: 0,
  BOX: 1,
  FRIDGE: 2,
  SHIP: 3,
};

const INCIDENT_TYPE = {
  INCIDENT: "incident",
  CANCELLATION: "cancellation",
};

const INCIDENT_ENTITY_TYPE = {
  DDMPS: "ddmps",
  DDMIS: "ddmis",
  DETAILS: "details",
  ODETAILS: "odetails",
  PDETAILS: "pdetails",

  PLISTS: "plists",
  ORDERS: "orders",
  PORDERS: "porders",
};

const INCIDENT_ENTITY_TYPES = [
  INCIDENT_ENTITY_TYPE.DDMPS,
  INCIDENT_ENTITY_TYPE.DDMIS,
  INCIDENT_ENTITY_TYPE.DETAILS,
  INCIDENT_ENTITY_TYPE.ODETAILS,
  INCIDENT_ENTITY_TYPE.PDETAILS,
  INCIDENT_ENTITY_TYPE.PLISTS,
  INCIDENT_ENTITY_TYPE.ORDERS,
  INCIDENT_ENTITY_TYPE.PORDERS,
];

const INCIDENT_STATUS = {
  UNMANAGED: "unmanaged",
  MANAGED: "managed",
  CANCELLED: "cancelled",
};

const INCIDENT_ACTIONS = {
  CANCELLED: "cancelled",
  CANCELLED_FOR: "cancelled_for",
  REPLACEMENT: "replacement",
  DISCOUNT: "discount",
  CHANGE_WEIGHT: "change_weight",
};

const INCIDENT_ACTIONS_BATCH = {
  CANCELLED: "cancelled",
  CANCELLED_BY_PRODUCER: "cancelled_by_producer",
  CANCELLED_BY_MARKET: "cancelled_by_market",
  CANCELLED_BY_ISLAND: "cancelled_by_island",
  REMOVE_FROM_INCIDENT: "remove_from_incident",
};

const INCIDENT_ACTIONS_PRICE = {
  PROPORTIONALLY: "PROPORTIONALLY",
  CHARGE_PRODUCER: "CHARGE_PRODUCER",
  CHARGE_MARKET: "CHARGE_MARKET",
  CHARGE_ISLAND: "CHARGE_ISLAND",
};

const INVOICE_STATUS = {
  ISSUED: "ISSUED",
  TO_BE_ISSUED: "TO_BE_ISSUED",
};

const INVOICE_TYPE = {
  CUSTOMER: 1,
  MARKET: 2,
  PRODUCER: 3,
  ISLAND: 4,
};

const INVOICE_ACTIONS = {
  MARK_AS_CASHED: "MARK_AS_CASHED",
  CANCEL_CASHED: "CANCEL_CASHED",
  CANCEL_INVOICE: "CANCEL_INVOICE",
  DOWNLOAD_PDF: "DOWNLOAD_PDF",
  DOWNLOAD_CSV: "DOWNLOAD_CSV",
  MARK_AS_PAID: "MARK_AS_PAID",
  CANCEL_PAID: "CANCEL_PAID",
};

const INVOICE_ACTIONS_LABEL = {
  MARK_AS_CASHED: "segna come incassato",
  CANCEL_CASHED: "annulla incassato",
  CANCEL_INVOICE: "annulla fattura",
  DOWNLOAD_PDF: "scarica pdf",
  DOWNLOAD_CSV: "scarica csv",
  MARK_AS_PAID: "segna come pagato",
  CANCEL_PAID: "annulla pagato",
};

const gwtIvoiceActionLabel = (i18n) => {
  return {
    MARK_AS_CASHED: i18n.t("family.invoices.actions.cached_mark"),
    CANCEL_CASHED: i18n.t("family.invoices.actions.cached_cancel"),
    CANCEL_INVOICE: i18n.t("family.invoices.actions.cancel"),
    DOWNLOAD_PDF: i18n.t("family.invoices.actions.download_pdf"),
    DOWNLOAD_CSV: i18n.t("family.invoices.actions.download_csv"),
    MARK_AS_PAID: i18n.t("family.invoices.actions.paid_mark"),
    CANCEL_PAID: i18n.t("family.invoices.actions.paid_cancel"),
  };
};
const AUTO_INVOICE_TYPE = {
  DATE: 1,
  AMOUNT_EXCEEDED: 2,
};

const AUTO_INVOICE_SCHEDULE = {
  MONTH_BEGINNING: 1,
  MONTH_10: 2,
  MONTH_15: 3,
  MONTH_END: 4,
};

const FAMILY_TYPE = {
  PRIVATE: "1",
  SOCIETY: "2",
  COOP: "3",
};

const ROLE_TYPE = {
  MARKET: 1,
  PRODUCER: 2,
  PRODUCERISLAND: 3,
  ISLAND: 4,
  SHOP: 5,
};

const languages = [
  { flag: flagSet.cifIt, language: "it", title: "Italiano" },
  { flag: flagSet.cifGb, language: "en", title: "English" },
  { flag: flagSet.cifDe, language: "de", title: "Deutsch" },
  { flag: flagSet.cifFr, language: "fr", title: "Français" },
];

const languageOptions = languages.map((item) => {
  return { value: item.language, label: item.title };
});

const producersProgressMap = (i18n) => {
  return [
    {
      id: 1,
      color: "sand",
      label: i18n.t("models.orderStatus.atProducer"),
      status: [ORDER_STATUS.PRODUCER_IN_CHARGE],
    },
    {
      id: 2,
      color: "green",
      label: i18n.t("models.orderStatus.atStorage"),
      status: [ORDER_STATUS.MARKET_ARRIVED],
    },
    {
      id: 3,
      color: "brown",
      label: i18n.t("models.orderStatus.ready"),
      status: [
        ORDER_STATUS.MARKET_IN_CHARGE,
        ORDER_STATUS.ISLAND_ARRIVED,
        ORDER_STATUS.ISLAND_IN_CHARGE,
        ORDER_STATUS.FAMILY_IN_CHARGE,
        ORDER_STATUS.DELIVERED,
        ORDER_STATUS.PAID,
      ],
    },
    {
      id: 4,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
    /*
    {
      id: 5,
      color: "emerald",
      label: i18n.t("models.orderStatus.inStock"),
      status: [ORDER_STATUS.MARKET_STOCK],
    },
    */
    {
      id: 6,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        ORDER_STATUS.ERROR,
      ],
    },
  ];
};

const ddmiProgressMap = (i18n) => {
  return [
    {
      id: 1,
      color: "cyan",
      label: i18n.t("models.orderStatus.notReady"),
      status: [
        ORDER_STATUS.PRODUCER_IN_CHARGE,
        ORDER_STATUS.MARKET_ARRIVED,
        ORDER_STATUS.MARKET_STOCK,
      ],
    },
    {
      id: 2,
      color: "sand",
      label: i18n.t("models.orderStatus.readyPackaged"),
      status: [ORDER_STATUS.MARKET_IN_CHARGE],
    },
    {
      id: 3,
      color: "green",
      label: i18n.t("models.orderStatus.deliveredToIsland"),
      status: [ORDER_STATUS.ISLAND_ARRIVED, ORDER_STATUS.ISLAND_IN_CHARGE],
    },
    {
      id: 4,
      color: "brown",
      label: i18n.t("models.orderStatus.deliveredToClient"),
      status: [
        ORDER_STATUS.FAMILY_IN_CHARGE,
        ORDER_STATUS.DELIVERED,
        ORDER_STATUS.PAID,
      ],
    },
    {
      id: 5,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
    {
      id: 6,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        ORDER_STATUS.ERROR,
      ],
    },
  ];
};

const ddmiProgressMapIsland = (i18n) => {
  return [
    {
      id: 1,
      color: "cyan",
      label: i18n.t("models.orderStatus.notReadyIsland"),
      status: [
        ORDER_STATUS.PRODUCER_IN_CHARGE,
        ORDER_STATUS.MARKET_ARRIVED,
        ORDER_STATUS.MARKET_STOCK,
        ORDER_STATUS.MARKET_IN_CHARGE,
        ORDER_STATUS.ISLAND_ARRIVED,
      ],
    },
    {
      id: 3,
      color: "sand",
      label: i18n.t("models.orderStatus.deliveredToIsland"),
      status: [ORDER_STATUS.ISLAND_IN_CHARGE],
    },
    {
      id: 4,
      color: "green",
      label: i18n.t("models.orderStatus.deliveredToClient"),
      status: [
        ORDER_STATUS.FAMILY_IN_CHARGE,
        ORDER_STATUS.DELIVERED,
        ORDER_STATUS.PAID,
      ],
    },
    {
      id: 5,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
    {
      id: 6,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        ORDER_STATUS.ERROR,
      ],
    },
  ];
};

const whProgressMap = (i18n) => {
  return [
    {
      id: 1,
      color: "cyan",
      label: i18n.t("models.orderStatus.atProducer"),
      status: [ORDER_STATUS.PRODUCER_IN_CHARGE],
    },
    {
      id: 2,
      color: "sand",
      label: i18n.t("models.orderStatus.deliveredToWh"),
      status: [ORDER_STATUS.MARKET_ARRIVED, ORDER_STATUS.MARKET_STOCK],
    },
    {
      id: 3,
      color: "green",
      label: i18n.t("models.orderStatus.readyPackaged"),
      status: [ORDER_STATUS.MARKET_IN_CHARGE],
    },
    {
      id: 4,
      color: "brown",
      label: i18n.t("models.orderStatus.deliveredToIsland"),
      status: [
        ORDER_STATUS.ISLAND_ARRIVED,
        ORDER_STATUS.ISLAND_IN_CHARGE,
        ORDER_STATUS.FAMILY_IN_CHARGE,
        ORDER_STATUS.DELIVERED,
        ORDER_STATUS.PAID,
      ],
    },
    {
      id: 5,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
    {
      id: 6,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        // ORDER_STATUS.PRODUCER_IN_CHARGE,
        ORDER_STATUS.ERROR,
      ],
    },
  ];
};

const ordersProgressMap = (i18n) => {
  return [
    {
      id: 1,
      color: "cyan",
      label: i18n.t("models.orderStatus.atMarket"),
      status: [
        ORDER_STATUS.PRODUCER_IN_CHARGE,
        ORDER_STATUS.MARKET_ARRIVED,
        ORDER_STATUS.MARKET_STOCK,
        ORDER_STATUS.MARKET_IN_CHARGE,
      ],
    },
    {
      id: 2,
      color: "sand",
      label: i18n.t("models.orderStatus.toDeliver"),
      status: [ORDER_STATUS.ISLAND_ARRIVED, ORDER_STATUS.ISLAND_IN_CHARGE],
    },
    {
      id: 3,
      color: "green",
      label: i18n.t("models.orderStatus.deliveredToClient"),
      status: [ORDER_STATUS.FAMILY_IN_CHARGE],
    },
    {
      id: 4,
      color: "brown",
      label: i18n.t("models.orderStatus.paid"),
      status: [ORDER_STATUS.DELIVERED, ORDER_STATUS.PAID],
    },
    {
      id: 5,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
    {
      id: 6,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        ORDER_STATUS.ERROR,
      ],
    },
  ];
};

const incidentProgressMap = (i18n) => {
  return [
    {
      id: 1,
      color: "sand",
      label: i18n.t("models.incidentStatus.open"),
      status: [INCIDENT_STATUS.UNMANAGED],
    },
    {
      id: 2,
      color: "green",
      label: i18n.t("models.incidentStatus.resolved"),
      status: [INCIDENT_STATUS.MANAGED],
    },
    {
      id: 3,
      color: "gray",
      label: i18n.t("models.incidentStatus.cancelled"),
      status: [INCIDENT_STATUS.CANCELLED],
    },
  ];
};

const roundListProgressMap = (i18n) => {
  return [
    {
      id: 0,
      color: "pink",
      label: i18n.t("models.orderStatus.inApproval"),
      status: [
        ORDER_STATUS.CREATE,
        ORDER_STATUS.PAYMENT_WAIT,
        ORDER_STATUS.APPROVAL,
        ORDER_STATUS.ALERT,
        ORDER_STATUS.ERROR,
      ],
    },
    {
      id: 1,
      color: "cyan",
      label: i18n.t("models.orderStatus.waitingForPickup"),
      status: [ORDER_STATUS.PRODUCER_IN_CHARGE],
    },
    {
      id: 2,
      color: "sand",
      label: i18n.t("models.orderStatus.toBePrepared"),
      status: [
        ORDER_STATUS.MARKET_ARRIVED,
        ORDER_STATUS.MARKET_IN_CHARGE,
        ORDER_STATUS.MARKET_STOCK,
      ],
    },
    {
      id: 3,
      color: "orange",
      label: i18n.t("models.orderStatus.inDelivery"),
      status: [ORDER_STATUS.ISLAND_ARRIVED, ORDER_STATUS.ISLAND_IN_CHARGE],
    },

    {
      id: 4,
      color: "green",
      label: i18n.t("models.orderStatus.delivered"),
      status: [ORDER_STATUS.FAMILY_IN_CHARGE],
    },
    {
      id: 5,
      color: "brown",
      label: i18n.t("models.orderStatus.paid"),
      status: [ORDER_STATUS.DELIVERED, ORDER_STATUS.PAID],
    },
    {
      id: 6,
      color: "gray",
      label: i18n.t("models.orderStatus.cancelled"),
      status: [ORDER_STATUS.CANCELED],
    },
  ];
};

export {
  ORDER_STATUS,
  ORDER_ACTION,
  LINES,
  INCIDENT_TYPE,
  INCIDENT_ENTITY_TYPE,
  INCIDENT_ENTITY_TYPES,
  INCIDENT_STATUS,
  INCIDENT_ACTIONS,
  INCIDENT_ACTIONS_BATCH,
  INCIDENT_ACTIONS_PRICE,
  INVOICE_STATUS,
  INVOICE_TYPE,
  INVOICE_ACTIONS,
  INVOICE_ACTIONS_LABEL,
  gwtIvoiceActionLabel,
  AUTO_INVOICE_TYPE,
  AUTO_INVOICE_SCHEDULE,
  FAMILY_TYPE,
  ROLE_TYPE,
  languages,
  languageOptions,
  producersProgressMap,
  ddmiProgressMap,
  ddmiProgressMapIsland,
  whProgressMap,
  ordersProgressMap,
  incidentProgressMap,
  roundListProgressMap,
};
